export default __webpack_public_path__ + "static/media/pse.685aa208.svg";